import axios from 'axios'
import qs from 'qs'
import config from '@/conf'

export default {
  // get请求
  async get(url, params, callback, router){
    // if(router){
    //   router = false
    // }
    !router && (router = false)
    // if(router){
    //   url = config.router + url
    // }
    !router && (url = config.router + url)
    try {
      let resData
      await axios.get(url, {params: params}).then((res) => {
        resData = res.data
      }).catch((err) => {
        console.log(err)
      })
      return resData
    }catch(e){
      console.log(e)
      return null
      this.$store.state.storeforload = false
    }
  },
  // post请求
  async post(url, params, callback, router){
    !router && (router = false)
    !router && (url = config.router + url)
    try {
      let resData
      await axios.post(url, qs.stringify(params)).then((res) => {
        resData = res.data
        if(callback){
          callback(res.data)
        }
        // console.log(resData)
      }).catch((err) => {
        console.log(err)
      })
      return resData
    }catch(e){
      console.log(e)
      this.$store.state.storeforload = false
      return null
    }
  },
  // jsonGet请求
  async jsonGet(url, callback){
    if(!url){
        console.error('Axios.JSONP 至少需要一个url参数!')
        return;
    }
    return new Promise((resolve,reject) => {
        window.jsonCallBack =(result) => {
          callback && (callback())
            resolve(result);
        };
        var JSONP=document.createElement("script");
        JSONP.type="text/javascript";
        JSONP.src=`${url}&callback=jsonCallBack`;
        document.getElementsByTagName("head")[0].appendChild(JSONP);
        setTimeout(() => {
            document.getElementsByTagName("head")[0].removeChild(JSONP)
        },500)
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/http.js